import { getUserId } from './authentication';

// This middleware filters out the current user's answers from the GraphQL response
export const filterUserAnswersMiddleware = (next: any) => async (req: any) => {
  const res = await next(req);

  // Skip if not a GraphQL query or if no data
  if (!res.json || !res.json.data) return res;

  // Get the current user ID
  const currentUserId = getUserId();

  // Filter out other users' answers for all possible arrays in the response
  if (res.json.data.contents?.edges) {
    res.json.data.contents.edges = res.json.data.contents.edges.map(edge => {
      if (edge.node?.collectionContents) {
        edge.node.collectionContents = edge.node.collectionContents.map(content => ({
          ...content,
          userCourseCollectionContents: content.userCourseCollectionContents.filter(c => c.user.id === currentUserId),
        }));
      }
      return edge;
    });
  }

  return res;
};
